import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { TABLET_WIDTH } from '../../constant';
import { Button } from '@chapche/ui';

const CreateNewGroupButton = () => {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const { i18n } = useTranslation();

    const navigateToPage = () => {
        navigate('/preference/group/new');
    };

    const createPreferenceGroupButtonName = (width) => {
        return width > TABLET_WIDTH ? i18n.t('app.page.preference.addGroup') : i18n.t('app.page.preference.addGroup').split(' ')[0];
    };

    return (
        <Button variant="outline" className="preference__button"
            onClick={navigateToPage}>
            {createPreferenceGroupButtonName(width)}
        </Button>
    );
};

export default CreateNewGroupButton;
